import { HasChildren } from '@eppendorf/vnls-react-components';
import cn from 'classnames';

import styles from './legend.module.scss';

export interface ChartLegendParam {
  value: string;
  color: string;
  show: boolean;
}

function Parameter({ value, color }: Omit<ChartLegendParam, 'show'>) {
  return (
    <div className={styles.chartLegendWrapperParameter}>
      <div
        role="status"
        aria-label="no-alerts"
        className={cn('circle', styles.chartLegendWrapperCircle)}
        style={{ backgroundColor: color }}
      />
      <span>{value}</span>
    </div>
  );
}

function ChartLegendWrapper({ children }: HasChildren) {
  return <div className={styles.chartLegendWrapper}>{children}</div>;
}

export const ChartLegend = Object.assign(ChartLegendWrapper, { Parameter });
